import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const PrimaryCurrencyQuery = gql`
  query {
    primaryCurrency {
      value
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

class GetPrimaryCurrencyQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { primaryCurrency }: any = this.props;
    return this.props.children({
      primaryCurrency
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(PrimaryCurrencyQuery, {
    name: 'primaryCurrency',
  })
)(GetPrimaryCurrencyQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Currencies/PrimaryCurrency.ts